import {Component, computed, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {MultiSelect} from 'primeng/multiselect';
import {ProviderColumn} from '../table/provider-results-table/provider-results-table.types';

interface ProviderOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-subcriteria-attribute-scores-provider-filter',
  imports: [FormsModule, TranslocoPipe, MultiSelect],
  templateUrl: './subcriteria-attribute-scores-provider-filter.component.html',
  styleUrls: ['./subcriteria-attribute-scores-provider-filter.component.scss'],
})
export class SubcriteriaAttributeScoresProviderFilterComponent {
  readonly providers = input.required<ProviderColumn[]>();
  readonly selectedProviderIds = input.required<string[]>();

  readonly selectedProviderIdsChange = output<string[]>();

  readonly providerOptions = computed<ProviderOption[]>(() =>
    this.providers().map((provider) => ({
      label: provider.translatedName,
      value: provider.hrToolDirectusId,
    })),
  );

  onSelectionChange(value: string[] | undefined): void {
    this.selectedProviderIdsChange.emit(value ?? []);
  }
}
